module.exports = __webpack_public_path__ + "Logo.b218e1b.png";